module.exports = __webpack_public_path__ + "img/37.16d2df1d.jpg";